import { lang } from '@umu/ukit-lang';
import { DataNode } from 'rc-tree/lib/interface';
enum SOURCE_DATA_TYPE {
    OUTER_URL = '0', // 外部链接
    COURSE = '1', // 课程
    PROGRAM = '2', // 学习项目
    CIRCLE = '3', // 学习圈
    SESSION = '4', // 小节
    LECTURER = '5', // 讲师
    MICRO_PAGES = '11', // 微页面
    PRACTICE_CHNNEL = '12', // 练习频道
    PRACTICE_OBJ = '13', // 练习
}

export const contentLinkNameMap = {
    [SOURCE_DATA_TYPE.OUTER_URL]: lang('外部链接'),
    [SOURCE_DATA_TYPE.COURSE]: lang('课程'),
    [SOURCE_DATA_TYPE.PROGRAM]: lang('学习项目'),
    [SOURCE_DATA_TYPE.CIRCLE]: lang('学习圈'),
    [SOURCE_DATA_TYPE.SESSION]: lang('小节'),
    [SOURCE_DATA_TYPE.LECTURER]: lang('讲师'),
    [SOURCE_DATA_TYPE.MICRO_PAGES]: lang(' 微页面'),
    [SOURCE_DATA_TYPE.PRACTICE_CHNNEL]: lang('练习'),
    [SOURCE_DATA_TYPE.PRACTICE_OBJ]: lang('练习'),
};

enum CHECKBOX_CHECK_TYPE {
    UN_CHECK,
    IS_CHECK,
    UNKNOWN_CHECK,
}
enum MEMBER_TYPE {
    USER = 'user',
    GROUP = 'group',
    CLASS = 'class',
    DEPARTMENT = 'department',
}
enum SOURCE_IMG_TYPE {
    CUSTOM, // 图片链接
    AVATAR, // 头像
    SESSION, //小节图标
    IMG_DATA, // 图片数据
    SVG_ICON, // 内置Svg
}
interface ISourceRes<T> {
    list: T[];
    page_info: IPageInfo;
}
type IData = Record<string, any>;
type IDataInfo = ISourceRes<any>;

interface IBasicItem {
    key?: string;
    id?: string;
    title: string;
    imgSrc: string;
    link: string;
    sourceImgType: number;
}
interface ITabPane {
    tab: string;
    key: string;
}
interface ISourceInfo extends IBasicItem {
    option?: {
        type: SOURCE_DATA_TYPE | number;
        id: string;
        contentId?: string;
        data?: IData;
    };
}
type ISearchParams = {
    [propName in string]?: string | number;
};
interface ISourceImg {
    title: string;
    imgSrc: string;
    link: string;
}
interface IDataSourceProps {
    isAllowDialogCheck?: boolean;
    isReloadCategory?: boolean;
    defaultLink?: string;
    size?: string;
    isNotCheckUrls?: boolean;
    isAllowAddMicroPage?: boolean;
    maxCount: number;
    isHideToolbar?: boolean;
    params?: ISearchParams;
    isKnowledge?: boolean; // 是否是知识库
    isHideMarket?: boolean;
    isHideSessionType?: boolean;
    isHideTab?: boolean;
    defaultTabIndex?: SOURCE_DATA_TYPE;
    list?: ISourceInfo[];
    categoryList?: DataNode[];
    isAllowRadio?: boolean;
    completeText?: string;
    tabList?: ITabPane[];
    userInfo?: IUserInfo;
    suffixElement?: JSX.Element | React.ReactNode;
    isMultiple?: boolean;
    onClose?: () => void;
    onBlur?: (value: string) => void;
    onCheckPermissionValid?: (list: ISourceInfo[]) => Promise<boolean[]>;
    getSourceImg?: (index: SOURCE_DATA_TYPE, item: IData) => ISourceImg;
    onSourceChange: (list: ISourceInfo[]) => void;
}
interface ISelectItem {
    id: string;
    label: string;
}
interface ICategoryParam {
    is_with_course_num: 0 | 1;
}
interface ICategory {
    id: string;
    parent_id: string;
    name: string;
    name_letter: string;
    show_index: string;
    auth_type: string;
    course_num: number;
    sub_category: ICategory[];
}
interface IPracticeChannelParam {
    se_id: string;
    page: number;
    size: number;
    status: 0 | 1;
    source?: number;
}
interface ISearchUserItem {
    avatar: string;
    email: string;
    id: string;
    login_name: string;
    group_name: string;
    phone: string;
    user_name: string;
    user_name_letter: string;
    department_id: string;
    department_name: string;
}
interface ISearchUserRes {
    department_list: ISearchUserItem[];
    list: ISearchUserItem[];
    page_info: IPageInfo;
}
interface ISearchMemberInfo {
    account: string;
    account_type: MEMBER_TYPE;
    avatar: string;
    email: string;
    name?: string;
    department_id?: string;
    department_name?: string;
    class_name?: string;
    group_name?: string;
    id: string;
    user_num?: number;
    is_exist: number;
    login_name: string;
    phone: string;
    student_id: string;
    umu_id: string;
    user_name: string;
}
interface ISearchInputItem {
    icon: string;
    title: string;
    label: string;
    id: string;
}
interface IUserSearchInputProps {
    isHideBorder?: boolean;
    placeholder: string;
    limitMax?: number;
    isClear?: boolean;
    hideOnMouseLeave?: boolean;
    onChange?: (item: string[]) => void;
    id?: string;
}

interface IPracticeChannelParams {
    se_id: string;
    auto_fill: number;
    page_id: string;
    ids: string;
    size?: number;
}

interface IPracticeChannelInfo {
    channel_id: string;
    title: string;
    video_num: number;
    video_preview: string[];
    practice_times: number;
}

export enum EnumTaskType {
    COURSE,
    LEARNING_PROJECT,
    SESSION,
    DAILY_EXAM,
    LEARNING_CIRCLE_CHECK_IN,
    ASSESSMENT_TASK,
}
export enum EnumAllTaskStatus {
    ALL_UNFINISHED = 1,
    PART_FINISHED,
    ALL_FINISHED,
    ALL_FINISHED_PERFECT,
}

export type ITaskListParams = {
    start_date: string;
    end_date: string;
};

export interface ITaskListData {
    task_type: `${EnumTaskType}`;
    [key: string]: any;
}
export interface ITaskListSummaryInfo {
    total_task_num: string;
    overall_completion_status: `${EnumAllTaskStatus}`;
    finish_radio: string;
}
export interface ITaskList {
    list: ITaskListData[];
    task_summary_info: ITaskListSummaryInfo;
}
export interface ITaskListRes {
    [key: string]: ITaskList;
}

export type IGetCalendarDataParams = {
    start_date: string;
    end_date: string;
};

export enum COMPLETION_STATUS {
    ALL_UN_FINISHED = 1, // 全部未完成
    PARTIALLY_COMPLETED, // 部分完成
    ALL_COMPLETED, // 全部完成
    ALL_COMPLETED_AND_ALL_EXAM_FULL_MARK, // 全部完成且全部考试满分
}

export interface ITodoCalendarInfo {
    total_task_num: number;
    finish_task_num: number;
    unfinish_task_num: number;
    finish_radio: number;
    overall_completion_status: COMPLETION_STATUS;
}

export type ITodoCalendarRes = Record<string, ITodoCalendarInfo>;

export enum PRACTICE_TYPE {
    HOMEWORK_VIDEO = 1,
    EXAM = 2,
    CHATBOT = 3,
}

export interface ObjListItem {
    obj_id: string;
    obj_type: PRACTICE_TYPE;
}

export const mapObjTypeToUrl = {
    [PRACTICE_TYPE.HOMEWORK_VIDEO]: 'video',
    [PRACTICE_TYPE.EXAM]: 'exam',
    [PRACTICE_TYPE.CHATBOT]: 'chatbot',
};

export {
    IData,
    ITabPane,
    ICategory,
    CHECKBOX_CHECK_TYPE,
    IUserSearchInputProps,
    ISearchInputItem,
    ISearchMemberInfo,
    ISearchUserItem,
    ISearchUserRes,
    IDataInfo,
    MEMBER_TYPE,
    ISourceRes,
    ISourceImg,
    ISelectItem,
    ICategoryParam,
    IPracticeChannelParam,
    SOURCE_IMG_TYPE,
    SOURCE_DATA_TYPE,
    ISearchParams,
    ISourceInfo,
    IBasicItem,
    IDataSourceProps,
    IPracticeChannelParams,
    IPracticeChannelInfo,
};
